var map = {
	"./game-00-hallo-welt/game.js": 81716,
	"./game-01-weltraum-maus/game.js": 22363,
	"./game-02-maus-blinzelt/game.js": 44071,
	"./game-03-maus-tanzt/game.js": 74536,
	"./game-04-wimmelbild/game.js": 38067,
	"./game-05-mathefant/game.js": 7205,
	"./game-06-listen-und-variablen/game.js": 55219,
	"./game-07-kunst-mit-der-maus/game.js": 25855,
	"./game-08-kugelfisch/game.js": 64419,
	"./game-09-wort-spiel/game.js": 75173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35143;